import React, { useRef } from "react";
import styled from "styled-components";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { stopSubmit } from "redux-form";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonMenuButton,
  IonContent,
  IonAlert,
  IonNote,
} from "@ionic/react";

import {
  AccountInformationForm,
  updateAccountInformation,
} from "../../../account";
import { AppStateDisplay } from "../../../common";
import strings from "../../../../res/strings";

const AccountSetupWizardContent = styled(IonContent)``;
const SetupInstructionsContent = styled.div`
  padding: 24px 24px 24px 24px;
`;
const Instructions = styled(IonNote)`
  font-size: 1em;
`;

const NonInputFieldErrorAlert = styled(IonAlert)``;

// TODO: As of now this is a single page wizard. In the future allow it to be modular and multi-page.
let AccountSetupWizard = (props) => {
  const contentRef = useRef(null);

  const submitUpdateAccountInformation = (values) => {
    if (props.credentials && values.birthdate) {
      let updatePostValues = {};
      updatePostValues.first_name = values.first_name;
      updatePostValues.middle_name = values.middle_name;
      updatePostValues.last_name = values.last_name;
      updatePostValues.birthday = values.birthdate.substring(0, 10);

      updatePostValues.contact_mobile = values.contact_mobile;
      updatePostValues.contact_landline = values.contact_landline;
      updatePostValues.contact_email = values.contact_email;

      updatePostValues.user_authtoken = props.credentials.authToken;

      props.updateAccountInformation({
        values: updatePostValues,
        content: contentRef,
        // closeActiveFormEdit,
        processingState: {
          message: strings.lib_common_state_loading,
          context: "lib_account.updateAccountInformation.accountSetupWizard",
        },
        successState: {
          context: "lib_account.updateAccountInformation.accountSetupWizard",
        },
        errorState: (error) => ({
          ...error,
          notificationType: "alert",
          context: "lib_account.updateAccountInformation.accountSetupWizard",
        }),
      });
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>{strings.lib_common_title_account_setup}</IonTitle>
          <IonButtons slot="start">
            <IonMenuButton autoHide={false}></IonMenuButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <AccountSetupWizardContent ref={contentRef}>
        <AppStateDisplay parsedQuery={props.parsedQuery}>
          <NonInputFieldErrorAlert
            isOpen={
              props.accountInformationForm &&
              props.accountInformationForm.submitFailed
            }
            header={strings.lib_common_state_error_submit}
            subHeader={strings.lib_common_state_error_submit_missing_fields}
            message={
              strings.lib_common_state_error_submit_missing_fields_details
            }
            buttons={[strings.lib_common_action_ok]}
            onDidDismiss={() => {
              // props.stopSubmit("lib_account_account_information_form");
            }}
          />
          <SetupInstructionsContent>
            <Instructions color="primary">
              {strings.lib_common_instructions_account_setup_information}
            </Instructions>
          </SetupInstructionsContent>
          <AccountInformationForm onSubmit={submitUpdateAccountInformation} />
        </AppStateDisplay>
      </AccountSetupWizardContent>
    </IonPage>
  );
};

const mapStateToProps = (state) => ({
  credentials: state.lib_authentication.credentials,
  accountInformationForm: state.form.lib_account_account_information_form,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      stopSubmit,
      updateAccountInformation,
    },
    dispatch
  );

AccountSetupWizard = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountSetupWizard);
export default AccountSetupWizard;
